import { css } from "@emotion/react";
import { ArrowBackIos } from "@material-ui/icons";
import styled, { ThemedCssCreator } from "../../../../../config/emotion";

export const detailNavContainerCss = css`
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 1050;
  padding-right: 0.5rem;
  background-color: white;
`;

export const ArrowBack = styled(ArrowBackIos)`
  font-size: 18px !important;
  color: ${({ theme }) => theme.colors.secondaryColor};
`;

export const pageNameCss: ThemedCssCreator = ({ colors }) => css`
  color: ${colors.secondaryColor};
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none; // takov8 maličkost abych s tooltipem zbytečně neoznačoval text
`;
